import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Modal } from 'react-bootstrap'
import DatePicker from "react-datepicker"

import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'

import { httpOk, GET, POST } from 'helpers/api'
import {
    formatDate, formatMoney, returnSign,
    returnMinDate, formatMoneyInput
} from 'helpers/helpers'

function Index() {
    const { t } = useTranslation()
    const reduxAccount = useSelector(state => state.account)
    const date = new Date()

    const [data, setData] = useState([])
    const [modalPayment, setModalPayment] = useState(false)
    const [modalWriteOff, setModalWriteOff] = useState(false)
    const [selectedItem, setSelectedItem] = useState({ 'created_at': date })
    const [filterDataExist, setFilterDataExist] = useState(false)
    const [filterData, setFilterData] = useState({})
    const [pagination, setPagination] = useState({
        url: `/cheques`,
        response: null
    })

    async function searchWithFilter() {
        var filterUrl = `/cheques`
        var urlParams = ""
        checkFilter()

        if (filterData.search)
            urlParams += returnSign(urlParams) + 'search=' + filterData.search
        if (filterData.page)
            urlParams += returnSign(urlParams) + 'page=' + filterData.page
        if (filterData.size)
            urlParams += returnSign(urlParams) + 'size=' + filterData.size

        if (`/cheques${urlParams}` !== filterUrl)
            setFilterDataExist(true)

        filterUrl = filterUrl + urlParams

        const response = await GET(filterUrl, {}, { loader: true })
        if (httpOk(response)) {
            setData(response.data)
            setPagination({ ...pagination, 'url': filterUrl, 'response': response.data })
        }
    }

    async function payment(e) {
        e.preventDefault();

        var selectedItemCopy = { ...selectedItem }
        selectedItemCopy.created_at = formatDate(selectedItemCopy.created_at, 'yyyy-MM-dd')

        var response = await POST('/suppliers-payment', selectedItemCopy, { loader: true })

        if (httpOk(response)) {
            toggleModalPayment(false)
            searchWithFilter()
        }
    }

    async function writeOff(e) {
        e.preventDefault();

        var response = await POST('/suppliers/writeoff-debt', selectedItem, { loader: true })

        if (httpOk(response)) {
            toggleModalWriteOff(false)
            searchWithFilter()
        }
    }

    function toggleModalPayment(bool = false, item = null) {
        var itemCopy = { ...item }

        if (bool) {
            itemCopy.created_at = new Date()
            setSelectedItem(itemCopy)
        } else {
            itemCopy.amount = ''
            itemCopy.note = ""
            itemCopy.created_at = new Date()
            setSelectedItem(itemCopy)
        }

        setModalPayment(bool)
    }

    function toggleModalWriteOff(bool = false, item = null) {
        var itemCopy = { ...item }

        if (bool) {
            itemCopy.amount = item.balance
            itemCopy.note = ""
        }

        setSelectedItem(itemCopy)
        setModalWriteOff(bool)
    }

    function resetFilter() {
        setFilterData({
            start_date: formatDate(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd'),
            end_date: formatDate(new Date(), 'yyyy-MM-dd'),
            search: '',
        })

        searchWithFilter()
    }

    function checkFilter() {
        if (
            filterData.search === ''
        ) {
            setFilterDataExist(false)
        }
    }

    async function paginate(page, size) {
        setFilterData({ ...filterData, 'page': page, 'size': size })
    }

    useEffect(() => {
        searchWithFilter(false)
    }, [filterData.search, filterData.page, filterData.size]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            <div className="page-header">
                <h4 className="vertical-center h-100">
                    {t('cheques')} [{data.total}]
                </h4>
            </div>

            <div className="card">
                <div className="card-body">
                    <div className="d-flex justify-content-between flex-wrap mb-3">
                        <div className="d-flex gap-2">
                            <FilterSearch
                                filterData={filterData}
                                setFilterData={setFilterData}>
                            </FilterSearch>
                        </div>
                        <div className="d-flex gap-2">
                            <div className="vertical-center">
                                <h4><b>{t('amount')}</b>:</h4>
                            </div>
                            <div className="vertical-center">
                                <h5 className="text-end">
                                    <span className={`${data.total_amount >= 0 ? 'text-success' : 'text-danger'}`}>
                                        {formatMoney(data.total_amount)}
                                    </span>
                                </h5>
                            </div>
                        </div>
                    </div>

                    {filterDataExist &&
                        <div className="filter-block">
                            <div className="filter">
                                <strong>{t('filter')}</strong>
                                <br />
                                {filterData.search &&
                                    <span className="me-2">
                                        <b>{t('search')}: </b>
                                        <span>{filterData.search}</span>
                                    </span>
                                }
                            </div>
                            <div className="vertical-center">
                                <button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>
                                    {t('reset')}
                                </button>
                            </div>
                        </div>
                    }

                    <div className="table-responsive">
                        <table className="table table-bordered mb-0">
                            <thead>
                                <tr>
                                    <th style={{ 'minWidth': '33px' }} className="text-center">#</th>
                                    <th style={{ 'minWidth': '70px' }}>ID</th>
                                    <th style={{ 'width': '30%' }}>{t('login')}</th>
                                    <th style={{ 'width': '10%' }}>{t('shift')} №</th>
                                    {/* <th style={{ 'width': '60%' }}></th> */}
                                    <th style={{ 'width': '10%' }} className="text-center">{t('date')}</th>
                                    <th style={{ 'width': '50%' }} className="text-end">{t('amount')}</th>
                                    {/* <th style={{ 'minWidth': '33px' }}></th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {data?.data?.map((item, index) => (
                                    <tr className="tr-middle" key={index}>
                                        <td className="text-center">{item.row_number}</td>
                                        <td className="td-ellipsis">{item.id}</td>
                                        <td>{item.login}</td>
                                        <td>{item.shift_id}</td>
                                        <td className="text-center">{formatDate(item.created_at, 'dd.MM.yyyy HH:mm')}</td>
                                        <td className="text-end">{formatMoney(item.total_amount)}</td>
                                        {/* <td>
                                            <div className="table-dropdown">
                                                <Dropdown id={`dropdown-${index}`}>
                                                    <Dropdown.Toggle variant="outline-primary">
                                                        <i className="uil uil-ellipsis-v"></i>
                                                    </Dropdown.Toggle>

                                                    <Dropdown.Menu>
                                                        <div className="table-dropdown-item"
                                                            onClick={() => toggleModalPayment(true, item)}>
                                                            <i className="uil uil-transaction"></i>
                                                            {t('payment')}
                                                        </div>
                                                        <div className="table-dropdown-item text-danger"
                                                            onClick={() => toggleModalWriteOff(true, item)}>
                                                            <i className="uil-edit-alt"></i>
                                                            {t('write_off')}
                                                        </div>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>
                                        </td> */}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {pagination.response &&
                        <FilterPagination
                            pagination={pagination}
                            paginate={paginate}>
                        </FilterPagination>
                    }
                </div>
            </div>

            {/* MODAL PAYMENT */}
            <Modal show={modalPayment} animation={false} centered
                dialogClassName="update-modal-width" backdrop="static"
                onHide={() => toggleModalPayment(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('amortization')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={payment} autoComplete="off">
                        <div className="d-flex justify-content-between flex-wrap">
                            <span>{t('supplier')}</span>
                            <span>{selectedItem.name}</span>
                        </div>
                        <div className="form-group">
                            <label>{t('date')}</label>
                            <div className="calendar-input">
                                <DatePicker
                                    className="form-control"
                                    dateFormat="dd.MM.yyyy"
                                    selected={selectedItem.created_at ? new Date(selectedItem.created_at) : ''}
                                    onChange={(date) => setSelectedItem({ ...selectedItem, 'created_at': formatDate(date, 'yyyy-MM-dd') })}
                                    minDate={returnMinDate(new Date(), reduxAccount.backdate ?? 3)}
                                    maxDate={new Date()}
                                />
                                <i className="uil uil-calendar-alt"></i>
                            </div>
                        </div>
                        <div className="form-group">
                            <label>{t('amount')}<span className="required-mark">*</span></label>
                            <input type="text" className="form-control" name="amount" autoFocus
                                value={selectedItem.amount ? formatMoneyInput(selectedItem.amount) : ''}
                                onChange={(e) => setSelectedItem({ ...selectedItem, 'amount': e.target.value.replace(/[^0-9.]/g, '') })} />
                        </div>
                        <div className="form-group">
                            <label>{t('note')}</label>
                            <input type="text" className="form-control" name="note"
                                value={selectedItem.note}
                                onChange={(e) => setSelectedItem({ ...selectedItem, 'note': e.target.value })} />
                        </div>
                        <div className="d-flex w-100 mt-3">
                            <button type="button" className="btn btn-outline-warning w-100 me-2"
                                onClick={() => toggleModalPayment(false)} tabIndex="-1">{t('cancel')}</button>
                            <button type="submit" className="btn btn-primary w-100" disabled={!selectedItem.amount}>
                                {t('save')}
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
            {/* MODAL PAYMENT */}

            {/* MODAL WRITE OFF */}
            <Modal show={modalWriteOff} animation={false} centered
                dialogClassName="update-modal-width" backdrop="static"
                onHide={() => toggleModalWriteOff(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('write_off_debt')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={writeOff} autoComplete="off">
                        <div className="form-group">
                            <label>{t('amount')}<span className="required-mark">*</span></label>
                            <input type="text" className="form-control" name="amount" autoFocus
                                value={selectedItem.amount ? formatMoney(selectedItem.amount) : ''}
                                disabled />
                        </div>
                        <div className="form-group">
                            <label>{t('note')}</label>
                            <input type="text" className="form-control" name="note"
                                onChange={(e) => setSelectedItem({ ...selectedItem, 'note': e.target.value })} />
                        </div>
                        <div className="d-flex gap-2 w-100 mt-3">
                            <button type="button" className="btn btn-outline-warning w-100"
                                onClick={() => toggleModalWriteOff(false)} tabIndex="-1">
                                {t('cancel')}
                            </button>
                            <button type="submit" className="btn btn-primary w-100">
                                {t('save')}
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
            {/* MODAL WRITE OFF */}
        </>
    )
}

export default Index
